module.exports = __webpack_public_path__ + "img/MITECO_FB_65h.98d3e2dc.png";